import { AttributeUiType } from '../attributes/attributeUiType';
import { EvaluationFilterResult } from './evaluationFilterResult';
import { IEvaluationQueryModel } from './evaluationQueryModel';
import * as _ from 'lodash';

export class PersonEvaluationResponsesDetail {
  public teamName: string;
  public evaluateePosition: string;
  public evaluationName: string;
  public lastEvaluationResponseDate: Date;
  public evaluatorsCount: number;
  public responses: IPersonEvaluationQuestionResponse[];

  static parse(data: EvaluationFilterResult): PersonEvaluationResponsesDetail {
    if (!data || data.values.length == 0) return null;
    let lastUpdatedevaluation = data.values.sort(
      (a: IEvaluationQueryModel, b: IEvaluationQueryModel) => {
        return +new Date(b.evaluationResponseDate) - +new Date(a.evaluationResponseDate);
      }
    )[0];
    let evaluation = new PersonEvaluationResponsesDetail();
    evaluation.evaluatorsCount = data.count;
    evaluation.teamName = lastUpdatedevaluation.teamName;
    evaluation.evaluateePosition = lastUpdatedevaluation.evaluateePosition;
    evaluation.evaluationName = lastUpdatedevaluation.evaluationName;
    evaluation.lastEvaluationResponseDate = lastUpdatedevaluation.evaluationResponseDate;
    let uniqQuestions: IPersonEvaluationQuestionResponse[] = [].concat(
      ..._.uniqBy(
        data.values.map((x) =>
          x.responses.map((r) => {
            return {
              questionId: r.questionId,
              questionName: r.questionName,
              questionType: r.questionType,
              isEnumeratedType:
                r.questionType == AttributeUiType.Checkboxes ||
                r.questionType == AttributeUiType.DropDown ||
                r.questionType == AttributeUiType.MultiSelect ||
                r.questionType == AttributeUiType.Skill,
              answers: [],
            };
          })
        ),
        'questionId'
      )
    );
    evaluation.responses = uniqQuestions.map((q) => {
      let response = [].concat(
        ...data.values.map((v) => {
          return [].concat(
            ...v.responses
              .filter((x) => x.questionId == q.questionId)
              .map((x) => {
                if (x.questionType == AttributeUiType.StarRating) {
                  return x.answers.filter((a) => a.value != '0').map((x) => x.value);
                } else {
                  return x.answers.map((x) => x.value);
                }
              })
          );
        })
      );
      q.answers = response;
      return q;
    });
    return evaluation;
  }
}

export interface IPersonEvaluationQuestionResponse {
  questionId: string;
  questionName: string;
  questionType: AttributeUiType;
  isEnumeratedType: boolean;
  answers: string[];
}
